import { memo, ReactNode } from 'react';
import TextField from 'presentations/views/components/atoms/TextField';
import Skeleton from 'presentations/views/components/atoms/Skeleton';

export interface Option {
  group?: GroupItem[];
  groupName?: string;
  text?: string | ReactNode;
  value: string | number | null;
  dataProps?: any;
}
export interface GroupItem {
  text: string | ReactNode;
  value: string | number | null;
}

interface Props {
  className?: string;
  isLoading?: boolean;
  isSkeleton?: boolean;
  isNative?: boolean;
  isDisabled?: boolean;
  label?: string;
  description?: string | ReactNode;
  value: string | number | null;
  isFullWidth?: boolean;
  isContainerFullWidth?: boolean;
  width?: number;
  loadingWidth?: number;
  size?: 'medium' | 'small';
  name?: string;
  prefix?: string;
  suffix?: string;
  variant?: 'outlined' | 'standard' | 'filled';
  outlineColor?: string;
  errors?: string[];
  helperText?: string;
  options?: Option[];
  onChange?: any;
  children?: ReactNode;
  isRequired?: boolean;
  isNotRequired?: boolean;
  isPaid?: boolean;
  isShowPaidLink?: boolean;
}

const Component = memo((props: Props) => {
  const options = props.options || [];

  if (props.isLoading && props.isSkeleton) {
    const width = props.loadingWidth || props.width || '100%';
    const height = 32;
    return <Skeleton width={width} height={height} />;
  }

  return (
    <TextField
      className={props.className}
      label={props.label}
      description={props.description}
      isSelect={true}
      prefix={props.prefix}
      suffix={props.suffix}
      variant={props.variant}
      isLoading={props.isLoading}
      isSelectNative={props.isNative}
      isDisabled={props.isDisabled}
      isFullWidth={props.isFullWidth}
      isContainerFullWidth={props.isContainerFullWidth}
      width={props.width}
      size={props.size}
      errors={props.errors}
      isPaid={props.isPaid}
      isShowPaidLink={props.isShowPaidLink}
      helperText={props.helperText}
      onChange={props.onChange}
      name={props.name}
      value={props.value}
      isRequired={props.isRequired}
      isNotRequired={props.isNotRequired}
      outlineColor={props.outlineColor}
    >
      {props.children ||
        options.map((option: any, i: number) => {
          const dataProps = option.dataProps || {};
          if (option.group && option.group.length > 0) {
            return (
              <optgroup key={option.value} label={option.groupName || ''}>
                {option.group.map((o: any, i: number) => (
                  <option key={o.value} value={o.value} {...dataProps}>
                    {o.text}
                  </option>
                ))}
              </optgroup>
            );
          } else {
            return (
              <option key={option.value} value={option.value} {...dataProps}>
                {option.text}
              </option>
            );
          }
        })}
    </TextField>
  );
});
export default Component;
